var _rect, _rect2, _rect3, _path, _circle, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 22,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#E5792C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 14,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#E5792C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 29,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#E5792C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8H32.5C34.7091 8 36.5 9.79086 36.5 12V17.0352C37.1813 17.0832 37.8491 17.1801 38.5 17.3222V12C38.5 8.68629 35.8137 6 32.5 6H12.5C9.18629 6 6.5 8.68629 6.5 12V32C6.5 35.3137 9.18629 38 12.5 38H23.3729C23.0047 37.3633 22.6851 36.695 22.4193 36H12.5C10.2909 36 8.5 34.2091 8.5 32V12C8.5 9.79086 10.2909 8 12.5 8Z",
    fill: "#E5792C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 30,
    r: 7,
    stroke: "#E5792C",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 34,
    width: 8,
    height: 2,
    rx: 1,
    transform: "rotate(40 39.5 34)",
    fill: "#E5792C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLog);
export default __webpack_public_path__ + "static/media/audit-log.966c9cc74fb8d9a694f5669d34c29eb8.svg";
export { ForwardRef as ReactComponent };